import {
  localizationEnUsInvoiceView,
  routerPageInvoiceView,
} from "./invoice-view";
import { localizationEnUsInvoices, routerPageInvoices } from "./invoices";
import { localizationEnUsOrderView, routerPageOrderView } from "./order-view";
import { localizationEnUsOrders, routerPageOrders } from "./orders";
import {
  localizationEnUsPaymentMethods,
  routerPagePaymentMethods,
} from "./payment-methods";

export const localizationEnUsBilling = {
  ...localizationEnUsInvoiceView,
  ...localizationEnUsInvoices,
  ...localizationEnUsOrderView,
  ...localizationEnUsOrders,
  ...localizationEnUsPaymentMethods,
};

export const routersPageBilling = [
  routerPageInvoiceView,
  routerPageInvoices,
  routerPageOrderView,
  routerPageOrders,
  routerPagePaymentMethods,
];
